export const convertNudgeToMSM = () => {
  const close = document.body.querySelector(
    "#priceNudgeIntervention .mobius-modal__close",
  ) as HTMLElement;
  const cta = document.body.querySelector(
    ".mobius-interventions__pricing-nudge-cta",
  ) as HTMLElement;
  const text = document.body.querySelector(
    ".mobius-interventions__pricing-nudge-text",
  ) as HTMLElement;

  if (close) close.style.setProperty("color", "#590f85");
  if (cta) cta.style.setProperty("background-color", "#590f85");
  if (text) text.style.setProperty("color", "black");
};
